export type SignInErrors = Record<string, string[]>;

interface FormData {
  email: string;
  password: string;
}

export const validateSignInForm = (formData: FormData): SignInErrors => {
  const errors: SignInErrors = {};
  if (!formData.email) {
    errors.username = ['メールアドレスを入力してください'];
  }
  if (!formData.password) {
    errors.password = ['パスワードを入力してください'];
  }
  return errors;
};
